import React from 'react';
import { StyleSheet, css } from 'aphrodite';

const BarCancelled = (props) => {
  const { title } = props;
  return (
    <div className={css(styles.bar)}>
      <div>{title ? <h3 className={css(styles.title)}>{title}</h3> : null}</div>
    </div>
  );
};

export default BarCancelled;

const styles = StyleSheet.create({
  bar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#ffe7e2d1',
    minHeight: 44,
    borderRadius: 2,
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: '#d1320e',
    margin: '10px 15px',
    fontWeight: '500',
  },
});



// WEBPACK FOOTER //
// ./src/components/BarCancelled/BarCancelled.js